import React from 'react';
import { Users } from 'lucide-react';
import { useWaitlistCount } from '../hooks/useWaitlistCount';
import confetti from 'canvas-confetti';

export function WaitlistStatusBar() {
  const { count, isAnimating } = useWaitlistCount();
  const goalSignups = 1500;

  // Trigger confetti when count changes
  React.useEffect(() => {
    if (isAnimating) {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0 }
      });
    }
  }, [isAnimating]);

  return (
    <div className="bg-blue-50 border-b border-blue-100">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Users 
              className={`text-blue-600 transition-transform duration-300 ${
                isAnimating ? 'scale-125' : ''
              }`} 
              size={20} 
            />
            <span className={`text-blue-900 font-medium transition-all duration-300 ${
              isAnimating ? 'text-green-600 scale-105' : ''
            }`}>
              {count} av 1500 på väntelistan just nu
            </span>
          </div>
          <div className="text-sm text-blue-700">
            Vi bygger tjänsten vid {goalSignups} anmälda på väntelistan
          </div>
        </div>
      </div>
    </div>
  );
}